// #genai Shared add-ach / add-card gate. Eligibility is unknown until billing data loads, so
// PENDING waits instead of treating "not loaded" as DENIED.
import { useSelector } from 'lib/redux';
import { ENABLE_MULTI_PAYMENT_METHODS } from 'constants/FeatureFlag.constants';
import {
  featureFlagSelector,
  isAchEligibleSelector,
  isBillingContextResolvedSelector,
} from 'utils/appSelectors.utils';

export const ADD_PAYMENT_ROUTE_ACCESS = {
  PENDING: 'pending',
  ALLOWED: 'allowed',
  DENIED: 'denied',
};

const useAddPaymentRouteAccess = () => {
  const isFlagEnabled = useSelector(featureFlagSelector(ENABLE_MULTI_PAYMENT_METHODS));
  const isAchEligible = useSelector(isAchEligibleSelector);
  const isBillingContextResolved = useSelector(isBillingContextResolvedSelector);

  if (!isFlagEnabled) return ADD_PAYMENT_ROUTE_ACCESS.DENIED;
  if (isAchEligible) return ADD_PAYMENT_ROUTE_ACCESS.ALLOWED;
  return isBillingContextResolved
    ? ADD_PAYMENT_ROUTE_ACCESS.DENIED
    : ADD_PAYMENT_ROUTE_ACCESS.PENDING;
};

export default useAddPaymentRouteAccess;
